import React from 'react';
import SelectedProduct from './Product/SelectedProduct'
import { useQuantityProductInCartConference, vibrate, cropString, isAllergen } from '../../Utils/Helpers';
import ProductPrice from './Product/ProductPrice';
import DOMPurify from 'dompurify';
import { TbPhotoX } from 'react-icons/tb';
import BadgeProductSale from './Product/BadgeProductSale';
import BadgeNewProduct from './Product/BadgeNewProduct';
import { useStoreHook } from '../../Hooks/StoreHook';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import BadgeAllergenTag from './Product/BadgeAllergenTag';
import BadgeProductTagFlag from './Product/BadgeProductTagFlag';
import { useNavigate } from 'react-router-dom';

interface CardProductFeaturedProps {
    product: any;
    loading?: boolean;
}

const CardProductFeatured = ({
    product,
    loading,
}: CardProductFeaturedProps) => {

    const { getLinkToHome, openProductToAdd } = useStoreHook();
    const { setEnableLoadProducts } = useLayoutContext();
    const navigate = useNavigate();

    const description = DOMPurify.sanitize(product.description);
    const quantitySelected = useQuantityProductInCartConference(product.id);

    const handleProduct = () => {

        openProductToAdd(product, product.categories[0]);
        setEnableLoadProducts(false);

        navigate(`${getLinkToHome()}/produto/${product.slug || product.id}`, { replace: true });
        vibrate();
    }

    return (
        <>
            {!loading
                ?
                    <div className="relative w-full h-full">

                        {/* ALLERGEN TAG  */}
                        <BadgeAllergenTag product={product} className='absolute w-full aspect-video z-10' />

                        <div onClick={handleProduct} className={`relative shadow flex flex-col w-full h-full rounded-xl hover:text-custom-primary cursor-pointer transition ease-in-out duration-200 
                            ring-1 ring-gray-100
                            active:shadow-lg
                            active:ring-4
                            active:ring-shopfood-title
                            hover:text-shopfood-title
                            hover:ring-transparent
                            md:hover:shadow-md
                            ${isAllergen(product) ? 'opacity-50' : ''}
                        `}>

                            {/* PRODUCT IN CART */}
                            {(quantitySelected > 0) && <SelectedProduct quantity={quantitySelected} />}

                            <div className="relative bg-cover bg-center bg-no-repeat aspect-video ring-b ring-0 ring-opacity-50 ring-gray-200 bg-gray-50 rounded-t-xl" style={{backgroundImage: `url(${product.photos?.medium})`}}>
                                {!product.photos?.medium &&
                                    <div className='flex items-center justify-center w-full h-full bg-gray-100 rounded-t-xl'>
                                        <TbPhotoX size={50} className='text-white' />
                                    </div>
                                }

                                {/* BADGE FOR NEW PRODUCT ON CATALOG */}
                                <BadgeNewProduct product={product} className='absolute bottom-0 left-0 rounded-tr' />

                                {/* PRODUCT SALE  */}
                                <BadgeProductSale product={product} className='absolute bottom-0 left-0 rounded-tr' />

                            </div>
                            <div className="flex flex-col justify-between gap-1 h-full p-3">
                                <h3 className="text-lg font-bold text-shopfood-title">{product.name}</h3>
                                <p className='h-full text-gray-500 leading-none md:text-sm' dangerouslySetInnerHTML={{ __html: cropString(description, 45) }} />
                                <h4 className="font-semibold mt-1 flex justify-between text-gray-500 leading-5">
                                    <ProductPrice product={product} />

                                    {/* PRODUCT TAG FLAG  */}
                                    <BadgeProductTagFlag product={product} className='absolute top-1.5 right-1.5' />
                                </h4>
                            </div>
                        </div>
                    </div>
                :
                    <div className="flex gap-4 w-full h-full rounded-xl ring-1 ring-gray-100 animate-pulse">
                        <div className="flex flex-col gap-4 justify-between flex-grow">
                            <div className="bg-gray-200 h-44 rounded-t-lg"></div>
                            <div className="flex flex-col gap-1.5 w-full p-3 pt-2">
                                <div className="bg-gray-200 w-4/5 h-5 mb-1 rounded"></div>
                                <div className="bg-gray-200 w-full h-2 rounded"></div>
                                <div className="bg-gray-200 w-2/3 h-2 rounded"></div>
                                <div className="bg-gray-200 w-2/4 h-2 rounded"></div>
                            </div>
                            <div className="flex gap-2 items-center p-4 pt-0">
                                <div className="bg-gray-200 h-6 w-1/3 rounded-lg"></div>
                            </div>
                        </div>
                    </div>
            }
        </>
    );
};

export default CardProductFeatured;
